export default __webpack_public_path__ + "static/media/Armwraps of the Harbinger.f461eb4c.jpg";